import { aspenApi as api, getFundList } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import type { IReqVentureList } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";

/**
 * 获取Fund产品列表。
 * @param {IReqVentureList} params - 获取Fund产品列表所需的参数。
 */
export const useFetchFundList = (params: IReqVentureList) => {
  const apiPath = api.fund.fundList;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<any>(queryKey);
  const { error, data, isLoading, refetch, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    placeholderData: cacheData,
    queryFn: () => {
      return getFundList(params).then(res => {
        if (res?.code == "0") {
          return res?.data;
        }
      });
    },
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading };
};
